// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"72":"3cdccf4d","175":"f96e30c3","253":"0d17cccb","652":"58bd3ac0","845":"b9dfafd4"}[chunkId] + ".css";
};